<template>
  <div class="prosedur align-items-center margin-setting">
    <div class="sd-heading align-self-stretch p-2">
      <p class="f-Overpass f-w-600 f-20 my-2 mx-3 align-items-start">
        Petunjuk penggunaan
      </p>
    </div>

    <div
      class="sd-body d-flex flex-column p-a-16 align-items-start align-self-stretch"
    >
      <ul class="content-list f-Overpass f-14 f-w-400">
        <li>Arahkan kamera menuju QR code mesin</li>
        <li>Pilih layanan yang ingin anda pakai</li>
        <li>Saldo anda akan otomatis berkurang sesuai layanan yang dipilih</li>
        <li>Mesin siap digunakan</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "cardScan",
};
</script>

<style scoped>
.prosedur {
  border-radius: 16px;
  background: var(--primary-white, #fff);
  box-shadow: 0px 4px 12px 0px rgba(0, 34, 119, 0.06);
}

.sd-heading {
  color: #fff;
  border-radius: 16px 16px 0px 0px;
  background: var(--primary-product-smartlink, #206cfe);
}

.sd-body {
  gap: 10px;
  border-radius: 0px 0px 16px 16px;
}

ul.content-list {
  padding-left: 24px;
}

.content-list li {
  margin-bottom: 10px;
}
.margin-setting {
  margin-top: 20px;
}
</style>
